var initialState = {
  outlets: [],
  shopId: "",
  empId: "",
  userId10Digit: "",
  shopAddress: "",
  userPincode: "",
  phoneNumber: "",
  shopIconLocation: "",
  shopImageLocation: "",
  outletArea: "",
  access: [],
  shopGST: "",
};

const outletReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_OUTLETS":
      return {
        ...state,
        outlets: action.payload,
      };
    case "SET_OUTLET_DETAILS":
      return {
        ...state,
        shopId: action.payload.ownerShopId
          ? action.payload.ownerShopId
          : action.payload.userId,
        empId: action.payload.ownerShopId ? action.payload.userId : "",
        shopName: action.payload.shopName,
        employeeName: action.payload.employeeName,
        shopAddress: action.payload.shopAddress,
        userPincode: action.payload.userPincode,
        phoneNumber: action.payload.userPhoneNumber,
        userId10Digit: action.payload.userId10Digit,
        userType: action.payload.userType,
        shopGST: action.payload.shopGST,
        shopIconLocation: action.payload.shopIconLocation
          ? action.payload.shopIconLocation
          : "removed",
        shopImageLocation: action.payload.shopImageLocation
          ? action.payload.shopImageLocation
          : "removed",
        websiteUrl: action.payload.websiteUrl ? action.payload.websiteUrl : "",
        access: action.payload.ownerShopId ? action.payload.access : [],
        taxMaster: action.payload.taxMaster ? action.payload.taxMaster : [],
        categoryList: action.payload.categoryList
          ? action.payload.categoryList
          : {},
      };
    default:
      return state;
  }
};

export default outletReducer;
